import React from 'react';
import { ArrowUpIcon, ArrowDownIcon } from 'lucide-react';
const mockData = [{
  id: 1,
  date: '2024-03-15',
  client: 'Juan Pérez',
  amount: 15000,
  status: 'approved',
  trend: 'up'
}, {
  id: 2,
  date: '2024-03-14',
  client: 'María García',
  amount: 8500,
  status: 'pending',
  trend: 'down'
}, {
  id: 3,
  date: '2024-03-13',
  client: 'Carlos López',
  amount: 12000,
  status: 'approved',
  trend: 'up'
}];
export const DashboardTable = () => {
  return <div className="overflow-x-auto" data-id="element-384">
      <table className="min-w-full divide-y divide-gray-200" data-id="element-385">
        <thead data-id="element-386">
          <tr data-id="element-387">
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-388">
              Fecha
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-389">
              Cliente
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-390">
              Monto
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-391">
              Estado
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-392">
              Tendencia
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200" data-id="element-393">
          {mockData.map(item => <tr key={item.id} className="hover:bg-gray-50 transition-colors" data-id="element-394">
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-395">
                {item.date}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-396">
                {item.client}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-397">
                ${item.amount.toLocaleString()}
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-398">
                <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${item.status === 'approved' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-399">
                  {item.status === 'approved' ? 'Aprobado' : 'Pendiente'}
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-400">
                {item.trend === 'up' ? <ArrowUpIcon className="h-5 w-5 text-green-500" data-id="element-401" /> : <ArrowDownIcon className="h-5 w-5 text-red-500" data-id="element-402" />}
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
};